import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { SkillStatusHeading } from "../../../../utils/Constant";
import { skillChart } from "../../../../Data/Widgets/WidgetsChartData";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";

const SkillStatus = () => {
  return (
    <Col xl="6" lg="12" className="box-col-6 xl-50">
      <Card>
        <CardHeaderCommon title={SkillStatusHeading} />
        <CardBody>
          <div className="chart-container skill-chart">
            <ReactApexChart options={skillChart} series={skillChart.series} type="radialBar" height={375}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SkillStatus;
